import React from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ExternalLink, Save } from "lucide-react";
import { ADMIN } from "@/constants/testIds";

export default function AdminApiLogin() {
  const [cfg, setCfg] = React.useState(null);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => { api.get("/api-config").then((r) => setCfg(r.data)); }, []);

  if (!cfg) return <div className="text-[color:var(--sky-admin-muted)]">Loading…</div>;

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/api-config", cfg);
      toast.success("Configuration saved");
    } catch { toast.error("Failed to save"); }
    finally { setSaving(false); }
  };

  const open = () => {
    if (!cfg.url) { toast.error("Configure a URL first"); return; }
    window.open(cfg.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <div className="overline text-[color:var(--sky-cyan)]">Hidden tab</div>
      <h1 className="mt-3 font-display font-black text-white text-3xl">API Login</h1>
      <p className="mt-2 text-[color:var(--sky-admin-muted)] max-w-2xl">Configure your 3rd-party API application. Clicking &ldquo;Open API app&rdquo; will launch the integrated app in a new secure tab. This tab is not visible on the public site.</p>

      <div className="mt-8 admin-card p-6 grid gap-5">
        <div className="grid gap-1">
          <label className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)] font-bold">Label</label>
          <input className="admin-input" value={cfg.label} onChange={(e) => setCfg({ ...cfg, label: e.target.value })} />
        </div>
        <div className="grid gap-1">
          <label className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)] font-bold">API app URL</label>
          <input className="admin-input" placeholder="https://your-3rd-party-app.example.com" value={cfg.url} onChange={(e) => setCfg({ ...cfg, url: e.target.value })} />
        </div>
        <div className="grid gap-1">
          <label className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)] font-bold">Description</label>
          <textarea rows={3} className="admin-input" value={cfg.description} onChange={(e) => setCfg({ ...cfg, description: e.target.value })} />
        </div>

        <div className="flex flex-wrap gap-3 mt-2">
          <button data-testid={ADMIN.saveBtn("api-login")} onClick={save} disabled={saving} className="admin-btn inline-flex items-center gap-2 disabled:opacity-60"><Save size={14} /> {saving ? "Saving…" : "Save"}</button>
          <button data-testid={ADMIN.apiLoginOpen} onClick={open} className="admin-btn-ghost inline-flex items-center gap-2 text-sm">Open API app <ExternalLink size={13} /></button>
        </div>

        {cfg.url && (
          <div className="mt-4 pt-4 border-t border-[color:var(--sky-admin-border)]">
            <div className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)] font-bold">Preview</div>
            <a href={cfg.url} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-2 text-[color:var(--sky-cyan)] hover:underline break-all">{cfg.url} <ExternalLink size={13} /></a>
          </div>
        )}
      </div>
    </div>
  );
}
